/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_All_RequiredInputs */

const en_lessons_all_required = /** @type {(inputs: Lessons_All_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All fields are required.`)
};

const he_lessons_all_required = /** @type {(inputs: Lessons_All_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל השדות נדרשים.`)
};

/**
* | output |
* | --- |
* | "All fields are required." |
*
* @param {Lessons_All_RequiredInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_all_required = /** @type {((inputs?: Lessons_All_RequiredInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_All_RequiredInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_all_required(inputs)
	return he_lessons_all_required(inputs)
});